import React from 'react';
import { Warning } from '@tac/icons';

import type { GlobalSettingsQueryResult } from '@tac/sanity-client/types';

import { PageAlert, PageAlertDescription, PageAlertIcon, PageAlertTitle } from '@/components/v2/page-alert';

type MaintenanceBannerData = NonNullable<GlobalSettingsQueryResult>['maintenanceBanner'];

type Props = { banner: MaintenanceBannerData | null | undefined };

const MaintenanceBanner = ({ banner }: Props) => {
  if (!banner?.enabled) return null;
  if (!banner.heading) return null;

  return (
    <div className="container-default py-4">
      <PageAlert variant="info">
        <PageAlertIcon variant="info">
          <Warning />
        </PageAlertIcon>
        <PageAlertTitle>{banner.heading}</PageAlertTitle>
        {banner.body && <PageAlertDescription>{banner.body}</PageAlertDescription>}
      </PageAlert>
    </div>
  );
};

export default MaintenanceBanner;
